import { Injectable, Attribute } from '@angular/core';

import { ChildFormControlComponent } from '../../controls/child-form-control/child-form-control.component';
import { DesignerConfigurationService } from '../../services/designer-configuration.service';
import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { ControlTypeName } from '../../types/control-type-name';
import { AbstractControl, ControlViewModel } from '../../types/control.types';
import { controlsTraversalPipe } from '../../utils/control-translate';
import {
  ChildFormDataModel,
  DynamicFormDataHandlerModel,
  DynamicFormDataHandlerModelValue,
  DynamicFormDataModelData
} from '../utils/dynamic-form-context.type';
import { ControlModelPropertyEnum } from '../../types/control-model-property';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormRunHelperService {
  private associatedEntitiesName: string = ControlModelPropertyEnum.AssociatedEntities;
  private entityAttributeName = ControlModelPropertyEnum.EntityAttribute;

  constructor(private designerConfigurationService: DesignerConfigurationService) {}

  /**
   * è®¾ç½®æ§ä»¶å¼
   *
   * @memberof DynamicFormRunHelperService
   */
  setControlValue(control: AbstractControl<any>, dataValue: DynamicFormDataModelData, targetId: string) {
    control.dataConfig.targetId = targetId;

    if (control.type === ControlTypeName.childForm) {
      this.setChildFormControlValue(control, dataValue);
    } else {
      this.setControlValueSelf(control, dataValue);
    }

    // FIXME æå¯è½ä¼å¯¼è´èµå¼å®æåvalueå¼åçåååè§¦åmodelChangeç­äºä»¶åæ¬¡éªè¯ï¼ä¸è¿è¿ä¸ªé®é¢ä¸å¤§
    // TODO ä¸æ¬¡çæ¬æ¶ï¼å¯ä»¥è°æ´ä¸ä¸ï¼è¿éä¸åæ ¡éªï¼å¨é¨äº¤ç»æ§ä»¶èªè¡å¤çï¼æ¯æ¬¡èµå¼å®æåè¿è¡æ ¡éª--å¤æ­readOnlyï¼å¤§é¨åç»ä»¶ä¸éè¦æ¹å¨ï¼ä¸ªå«æèèªå®ä¹ç»ä»¶éè¦è°æ´---éè¦æµè¯ï¼
    this.validateControl(control);
  }

  /**
   * å­è¡¨åæ§ä»¶èµå¼
   *
   */
  private setChildFormControlValue(control: AbstractControl<any>, formData: DynamicFormDataModelData) {
    let data = formData.childrenFormData;
    if (!data) {
      data = [];
    }

    const childForm = control as ChildFormControlComponent;
    let formValue = data.find((s) => s.formCode === childForm.model.formCode);
    if (!formValue) {
      formValue = { formCode: childForm.model.formCode, data: [] };
    }
    childForm.setModelValue(formValue.data);
  }

  /**
   * æ®éç»ä»¶èµå¼
   *
   */
  private setControlValueSelf(control: AbstractControl<ControlViewModel>, formData: DynamicFormDataModelData) {
    const data = formData.controlsData;

    let hasValue = false;
    let obj: any = {};

    /**
     * æ°æ®æºå­æ®µåç§°éå
     */
    const dataMemberKeys: string[] = this.getControlEntityAttributeSourceKeys(control);

    if (!this.isHasAssociatedEntityAttribute(control, dataMemberKeys)) {
      control.setModelValue(undefined);
      return;
    }

    /**
     * æ°æ®æºè¡¨æ°æ®
     */
    const dataSource = data[control.model[this.associatedEntitiesName]];

    if (!dataSource) {
      control.setModelValue(undefined);
      return;
    }

    /**
     * ç»è¿åå¯¹è±¡èµå¼
     */
    const setObjValue = (key: string, valueKey: string) => {
      if (dataSource[valueKey] !== undefined) {
        // keyä¸ä¸ºç©ºï¼è¯´ææ¯å¤å±æ§ï¼é»è®¤å±æ§å°±æ¯''
        if (key) {
          obj[key] = dataSource[valueKey];
        } else {
          obj = dataSource[valueKey];
        }
        hasValue = true;
      }
    };

    // è·åå¼ï¼æ¼æ¥å¯¹è±¡
    dataMemberKeys.forEach((key) => {
      if (control.model.associatedEntityAttributes) {
        // è¯´ææ¯1.3.6ä¹åçï¼æç§æ°çå¤æ­
        const dataModel = control.model.associatedEntityAttributes.find((s) => s.source === key);
        if (dataModel) {
          // å¦ææ¯jsonkey åæ¹åkeyå¼
          let valueKey = dataModel.target;
          if (dataModel.jsonKey) {
            valueKey = valueKey + '.' + dataModel.jsonKey;
          }
          setObjValue(key, valueKey);
        }
      } else {
        const valueKey = control.model[this.entityAttributeName + key];
        setObjValue(key, valueKey);
      }
    });

    if (!hasValue) {
      control.setModelValue(undefined);
    } else {
      control.setModelValue(obj as any);
    }
  }

  /**
   * è·åå³èå®ä½å±æ§çæºkeys
   */
  private getControlEntityAttributeSourceKeys(control: AbstractControl<ControlViewModel>) {
    const dataMemberKeys: string[] = [];
    // åªådataMemberKey å¼å¤´çå±æ§
    Object.keys(control.model).map((s) => {
      if (s.startsWith(this.entityAttributeName)) {
        dataMemberKeys.push(s.substring(this.entityAttributeName.length));
      }
    });
    // 1.3.6ååå¼éè¦å ä¸å³èå®ä½å±æ§éåä¸­çå±æ§
    if (control.model.associatedEntityAttributes) {
      control.model.associatedEntityAttributes.forEach((attribute) => {
        if (attribute.target && !dataMemberKeys.includes(attribute.source)) {
          dataMemberKeys.push(attribute.source);
        }
      });
    }
    return dataMemberKeys;
  }

  /**
   * è®¾ç½®æ§ä»¶çè¡¨åç¼å·
   *
   * @memberof DynamicFormRunHelperService
   */
  setControlFormCode(control: AbstractControl<any>, formCode: string) {
    control.dataConfig.formCode = formCode;
  }

  /**
   * éåæææ§ä»¶è·åæ°æ®
   *
   * @memberof DynamicFormRunHelperService
   */
  getControlsValue(controls: Array<AbstractControl<any>>): DynamicFormDataModelData {
    const dynamicFormDataHandlerModels: Array<DynamicFormDataHandlerModel> = [];
    const childFormsData: ChildFormDataModel[] = [];
    controlsTraversalPipe(controls, (c) => this.getControlValue(c, dynamicFormDataHandlerModels, childFormsData));

    return {
      controlsData: this.convertFormDataKeyValueToJson(dynamicFormDataHandlerModels),
      childrenFormData: childFormsData
    };
  }

  /**
   * éªè¯åä¸ªæ§ä»¶éªè¯å¨
   *
   * @memberof DynamicFormRunHelperService
   */
  validateControl(control: AbstractControl<any>) {
    // å¼æ§ä»¶æéªè¯
    // controlä¸­çreadonlyææ§ä»¶æ¬èº«æ¯å¦åªè¯»ï¼viewOnlyææ¯å¦æ¥çæ¨¡å¼
    // control.modelä¸­ç readonly å¼å±æ§éç½®
    if (control instanceof AbstractValueControlBase && !control.readonly) {
      control.validate();
    }
  }

  /**
   * è·åä¸ä¸ªæ§ä»¶çæ°æ®
   *
   * @memberof DynamicFormRunHelperService
   */
  getControlValue(
    control: AbstractControl<ControlViewModel>,
    dynamicFormDataHandlerModels: Array<DynamicFormDataHandlerModel>,
    childrenFormData: ChildFormDataModel[]
  ) {
    // å¦ææ¯å­è¡¨å---
    const childFormControl = control as ChildFormControlComponent;
    if (childFormControl instanceof ChildFormControlComponent && childFormControl.isChildForm) {
      const formValue = childFormControl.getModelValue();
      childrenFormData.push({ formCode: childFormControl.model.formCode, data: formValue });
      return;
    }

    // åªådataMemberKey å¼å¤´çå±æ§
    const dataMemberKeys = this.getControlEntityAttributeSourceKeys(control);

    // å­å¨è¿ä¸¤ä¸ªå±æ§æåæ°æ®
    if (!this.isHasAssociatedEntityAttribute(control, dataMemberKeys)) {
      return;
    }

    let value: any = control.getModelValue();
    if (value === undefined || value === null) {
      value = null;
    }
    // å¤æ­control.model
    dataMemberKeys.forEach((key) => {
      const associatedEntity = control.model[this.associatedEntitiesName];

      if (control.model.associatedEntityAttributes) {
        const attribute = control.model.associatedEntityAttributes.find((s) => s.source === key);
        if (attribute) {
          let valueKey = attribute.target;
          if (attribute.jsonKey) {
            valueKey = valueKey + '.' + attribute.jsonKey;
          }

          this.pushControlValue(key ? value[key] : value, associatedEntity, valueKey, dynamicFormDataHandlerModels);
        }
        return;
      }

      const associatedEntityAttribute = control.model[this.entityAttributeName + key];
      if (key) {
        for (const v in value) {
          if (v === key) {
            this.pushControlValue(value[v], associatedEntity, associatedEntityAttribute, dynamicFormDataHandlerModels);
          }
        }
      } else {
        this.pushControlValue(value, associatedEntity, associatedEntityAttribute, dynamicFormDataHandlerModels);
      }
    });
  }

  /**
   * æ¯å¦å­å¨å³èå®ä½åå±æ§
   *
   * @memberof DynamicFormRunHelperService
   */
  isHasAssociatedEntityAttribute(control: AbstractControl<any>, dataMemberKeys: string[]) {
    return control.model.associatedEntities && dataMemberKeys.length > 0;
  }

  /**
   * ä¿å­æ§ä»¶çå¼å°model
   *
   * @param value å¼
   * @param dataSource æ°æ®æºè¡¨å
   * @param dataMember æ°æ®å­æ®µå
   * @param dynamicFormDataHandlerModels è¡¨åæ°æ®
   */
  pushControlValue(
    value: any,
    dataSource: string,
    dataMember: string,
    dynamicFormDataHandlerModels: Array<DynamicFormDataHandlerModel>
  ) {
    let items: Array<DynamicFormDataHandlerModelValue>;

    const filteredSource = dynamicFormDataHandlerModels.filter((x) => x.key === dataSource);
    if (filteredSource.length === 0) {
      const groupItem = {
        key: dataSource,
        value: new Array<DynamicFormDataHandlerModelValue>()
      };
      dynamicFormDataHandlerModels.push(groupItem);
      items = groupItem.value;
    } else {
      items = filteredSource[0].value;
    }
    items.push({ key: dataMember, value: value });
  }

  /**
   * è½¬æ¢è¡¨åæ°æ®æjsonæ ¼å¼
   *
   * @memberof DynamicFormRunHelperService
   */
  convertFormDataKeyValueToJson(model: Array<DynamicFormDataHandlerModel>): { [key: string]: any } {
    const formData: { [key: string]: any } = {};
    for (const c of model) {
      const key: string = c.key;
      if (c.key === undefined) {
        continue;
      }
      for (const t of c.value) {
        if (t.key === undefined) {
          continue;
        }
        if (formData[key] === undefined) {
          formData[key] = {};
        }
        formData[key][t.key] = t.value;
      }
    }
    return formData;
  }
}
